import { render, staticRenderFns } from "./BudgetChart.vue?vue&type=template&id=63e7153f&scoped=true&"
import script from "./BudgetChart.vue?vue&type=script&lang=js&"
export * from "./BudgetChart.vue?vue&type=script&lang=js&"
import style0 from "./BudgetChart.vue?vue&type=style&index=0&id=63e7153f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7153f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e7153f')) {
      api.createRecord('63e7153f', component.options)
    } else {
      api.reload('63e7153f', component.options)
    }
    module.hot.accept("./BudgetChart.vue?vue&type=template&id=63e7153f&scoped=true&", function () {
      api.rerender('63e7153f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/budget/BudgetChart.vue"
export default component.exports